import React, { memo } from "react";
import { RCCBadge, RCCGrid } from "react-common-components";
import UserColumn from "src/components/DefaultColumnsList/User";
import List from "src/components/List";
import WrapText from "src/components/WrapText";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import BadgeAnalysis from "../BadgeAnalysis";
import { TypeBadge } from "../ListAnalysis/interface";
import { IListRisk } from "./interface";

const ListRisks: React.FC<IListRisk> = ({
	data,
	options,
	filter,
	layout = undefined
}) => {
	const { translate, currentLanguage } = useTranslation();

	const colResponsavel = (row : any) => (
	  <UserColumn 
		  name={row.eftba005.efa005Nome}
		  image={row.eftba005.efa005Imagem}
	  />
	);

	const colData = (row : any) => (
	  <>
		  {formatDate(row.rib001Data, currentLanguage)}
	  </>
	);

	const colIncidencias = (row : any) => (
		<>
			<RCCGrid
				styleInline="@media (min-width: 600px){display: none}"
			>
				{translate("Incidentes")}:
			</RCCGrid>
			{row.ritbb004Lenght ? row.ritbb004Lenght : 0}
		</>
	);

	const colQuadrante = (row: any) => (
	  <>
		  <BadgeAnalysis 
			  value={row.rib001Quadrante}
			  type={TypeBadge.QUADRANT}
		  />
	  </>	
	);

	const colProbabilidade = (row: any) => (
	  <>
	  	  <RCCGrid
				styleInline="@media (min-width: 600px){display: none}"
			>
				{translate("Probabilidade")}:
			</RCCGrid>
			
		  <BadgeAnalysis 
			  value={row.rib001Probabilidade}
			  type={TypeBadge.PROBABILITY}
		  />
	  </>	
	);

	const colSituacao = (row : any) => (
	  <>
		  <BadgeAnalysis 
			  value={row.rib001Situacao}
			  type={TypeBadge.SITUATION}
		  />
	  </>
	);

	const colImpacto = (row : any) => (
	  <>
	   		<RCCGrid
				styleInline="@media (min-width: 600px){display: none}"
			>
				{translate("Impacto")}:
			</RCCGrid>
		  <BadgeAnalysis 
			  value={row.rib001Impacto}
			  type={TypeBadge.IMPACT}
		  />
	  </>
	);

	const colGrau = (row : any) => {
		if (row.rib001Grau <= 6)
		{
			return (
				<RCCBadge 
					color="green"
					styleInline="font-size: 0.83rem;"
				>
					{row.rib001Grau}
				</RCCBadge>
			);
		}
		if (row.rib001Grau < 18)
		{
			return (
				<RCCBadge 
					color="yellow"
					styleInline="font-size: 0.83rem;"
				>
					{row.rib001Grau}
				</RCCBadge>
			);
			
		}	
		return (
			<RCCBadge 
				color="red"
				styleInline="font-size: 0.83rem;"
			>
				{row.rib001Grau}
			</RCCBadge>
		);
	
	};

	return(
		<List 
			data={data}
			filter={filter}
			layout={layout}
			columns={[
				{
					idColumn: "fullTitle",
					nameColumn: translate("Título"),
					xs: 12,
					sm: 2,
					justify: "left",
					cellRenderer: (row:any) => <WrapText lineClamp={2} bold>{row.fullTitle}</WrapText>
				},
				{
					idColumn: "rib001Data",
					nameColumn: translate("Data"),
					xs: 12,
					sm: 1,
					justify: "center",
					cellRenderer: colData 
				},
				{
					idColumn: "rib001Quadrante",
					nameColumn: translate("Tipo"),
					xs: 12,
					sm: 1,
					justify: "center",
					hidden: ["sm"],
					cellRenderer: colQuadrante 
				},
				{
					idColumn: "rib001Probabilidade",
					nameColumn: translate("Probabilidade"),
					xs: 12,
					sm: 1,
					justify: "center",
					cellRenderer: colProbabilidade 
				},
				{
					idColumn: "rib001Impacto",
					nameColumn: translate("Impacto"),
					xs: 12,
					sm: 1,
					justify: "center",
					cellRenderer: colImpacto 
				},
				{
					idColumn: "rib001Grau",
					nameColumn: translate("Grau"),
					xs: 12,
					sm: 1,
					justify: "center",
					hidden: ["sm", "md"],
					cellRenderer: colGrau 
				},
				{
					idColumn: "eftba005",
					nameColumn: translate("Responsável"),
					xs: 12,
					sm: 2,
					md: 1,
					justify: "left",
					cellRenderer: colResponsavel 
				},
				{
					idColumn: "ritbb004",
					nameColumn: translate("Incidências"),
					xs: 12,
					sm: 1,
					justify: "center",
					hidden: ["sm", "md"],
					cellRenderer: colIncidencias
				},
				{
					idColumn: "processo",
					nameColumn: translate("Processo"),
					xs: 12,
					sm: 1,
					justify: "center",
					hidden: ["sm"]
				},
				{
					idColumn: "rib001Situacao",
					nameColumn: translate("Situação"),
					xs: 12,
					sm: 1,
					justify: "center",	
					cellRenderer: colSituacao,
					hidden: ["sm"]
				},
				{
					idColumn: "options",
					nameColumn: "",
					xs: 12,
					sm: 1,
					justify: "right",
					cellRenderer: options
				}
			]}
			showHeader
		/>
	);};

export default memo(ListRisks);
